import { useSave } from "lib/@hooks/use-save"
import { Bound } from "lib/@components/binding/Bound"
import { Alert, Stack, Typography } from "@mui/material"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { getClientAdvanced } from "./controller/get-client-advanced"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { setClientAdvanced } from "./controller/set-client-advanced"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BoundCheckBox } from "lib/@components/standard-checkbox"

export function Advanced() {
    const { clientId } = useBoundContext()
    const clientData = getClientAdvanced.useResults({ clientId })
    console.log({ clientData })

    const change = useSave({ save, target: clientData })

    if (!clientData) return null

    return (
        <Bound target={clientData} change={change}>
            <EditAdvanced />
        </Bound>
    )
}

async function save(clientData) {
    try {
        const update = {
            id: clientData.id,
            crmCompanyId: clientData.crmCompanyId,
            excludeFromReporting: clientData.excludeFromReporting,
        }
        await setClientAdvanced(update)
    } catch (e) {
        console.log({ e })
        errorSnackbar("Failed to update Company advanced settings")
    }
}

export function EditAdvanced() {
    const { target, change } = useBoundContext()
    const { crmCompanyId, excludeFromReporting } = target
    return (
        <Stack spacing={3} direction={{ xs: "column", sm: "column" }}>
            <Alert severity="warning">
                <Typography>
                    Setting this value will modify the FiQ -&gt; CRM link and should only be used for merged records.
                </Typography>
                {crmCompanyId && crmCompanyId?.length !== 0 && (
                    <Typography mt={2}>To revert to original id ({target.id}), clear the value below.</Typography>
                )}
            </Alert>
            <Bound target={target} onChange={change}>
                <BoundTextField field="crmCompanyId" id="editCrmCompanyId" />
            </Bound>

            {excludeFromReporting === true && (
                <Alert severity="warning">
                    <Typography>This company is excluded from System Info reporting.</Typography>
                </Alert>
            )}
            <Bound target={target} onChange={change}>
                <BoundCheckBox field="excludeFromReporting" id="editCrmExcludeFromReporting" />
            </Bound>
        </Stack>
    )
}
